import { render, staticRenderFns } from "./OffersEdit.vue?vue&type=template&id=d515ff1c&scoped=true&"
import script from "./OffersEdit.vue?vue&type=script&lang=js&"
export * from "./OffersEdit.vue?vue&type=script&lang=js&"
import style0 from "./OffersEdit.vue?vue&type=style&index=0&id=d515ff1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d515ff1c",
  null
  
)

export default component.exports